import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "resultCount",
    standalone: false
})
export class ResultCountPipe implements PipeTransform {
    public transform(value?: number, countLimit: number = 99): string {
        if (!value) return "0";
        const count: string = value > countLimit ? `${countLimit}+` : value.toString();
        return count;
    }
}
